"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSessionManager = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var UrlUtil_1 = require("../../utils/UrlUtil");
var authHub_1 = __importDefault(require("./authHub"));
var IdleTimer_1 = require("./IdleTimer");
var UserSessionStore_1 = require("./UserSessionStore");
var authHub = null;
var Servicecommunicator = styled_components_1.default.iframe(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: none;\n"], ["\n\tdisplay: none;\n"])));
Servicecommunicator.displayName = 'Servicecommunicator';
var UserSessionManager = /** @class */ (function (_super) {
    __extends(UserSessionManager, _super);
    function UserSessionManager(props) {
        var _this = _super.call(this, props) || this;
        _this.onIdle = _this.onIdle.bind(_this);
        _this.onAction = _this.onAction.bind(_this);
        var identityServerUrl = new URL(_this.props.identityServerUrl);
        _this.loadComponent = (+UrlUtil_1.UrlUtil.isLocalhost(identityServerUrl) ^ +UrlUtil_1.UrlUtil.isLocalhost(window.location)) === 0;
        _this.identityServerUrl = identityServerUrl.origin;
        _this.lastActiveTimeKey = _this.props.sessionKeyPrefix + '_User_LastActiveTime';
        return _this;
    }
    UserSessionManager.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.loadComponent) {
                            return [2 /*return*/];
                        }
                        // This event handler ensures that all open browser tabs refresh (and there by logout)
                        // when the user is logged out in any one of the tabs or when the session is expired in one of the tabs
                        UserSessionStore_1.UserSessionStore.addSignoutEventHandler(this.props);
                        UserSessionStore_1.UserSessionStore.addMessageEventListener(this.props);
                        return [4 /*yield*/, this.checkSessionIsActive()];
                    case 1:
                        _a.sent();
                        this.onAction();
                        if (!authHub) {
                            authHub = new authHub_1.default(this.props.identityServerUrl, function () { return _this.props.userManager.getUser().then(function (user) { var _a; return (_a = user === null || user === void 0 ? void 0 : user.access_token) !== null && _a !== void 0 ? _a : ''; }); });
                        }
                        authHub.onUserSessionEnded(function () { return UserSessionStore_1.UserSessionStore.logout(_this.props.userManager); });
                        return [4 /*yield*/, authHub.connect()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserSessionManager.prototype.render = function () {
        var _this = this;
        return !this.loadComponent ? null : (React.createElement(React.Fragment, null,
            React.createElement(IdleTimer_1.IdleTimer, { ref: function (ref) { return (_this.idleTimer = ref); }, onIdle: this.onIdle, onAction: this.onAction, debounce: 5000, timeout: 60000, events: ['keydown', 'wheel', 'DOMMouseScroll', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown'] }),
            React.createElement(Servicecommunicator, { src: "".concat(this.identityServerUrl, "/home/servicecommunicator"), id: 'servicecommunicator' })));
    };
    UserSessionManager.prototype.onIdle = function () {
        var timeOut = this.props.timeoutInSeconds * 1000;
        var prevTime = localStorage.getItem(this.lastActiveTimeKey);
        if (prevTime && Date.now() - +prevTime >= timeOut) {
            UserSessionStore_1.UserSessionStore.logout(this.props.userManager, this.props.identityServerUrl);
        }
        else {
            if (this.idleTimer) {
                this.idleTimer.reset();
            }
        }
    };
    UserSessionManager.prototype.onAction = function () {
        // we use local storage to be able to sync last active time between multiple open tabs
        localStorage.setItem(this.lastActiveTimeKey, String(Date.now()));
    };
    UserSessionManager.prototype.checkSessionIsActive = function () {
        // This has the effect of requesting a new access token
        // with the refresh token currently available in storage.
        // If the user session was terminated on the server,
        // this will fail, effectively causing a client-side sign out.
        return this.props.userManager.signinSilent();
    };
    return UserSessionManager;
}(React.PureComponent));
exports.UserSessionManager = UserSessionManager;
var templateObject_1;
